export default __webpack_public_path__ + "static/media/close-modal.486d3c22.svg";